export const invitaciones2026 = [
  {
    titulo: "CAASIM-HGO-INV3-OP-01-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-02-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-03-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-04-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-05-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-06-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-07-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-08-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-09-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-10-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-11-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-12-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-13-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-14-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-15-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-16-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-17-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-18-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-19-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-20-2026",
  },
  {
    titulo: "ITP-CAASIM-SRMySG-SAL-01-2026",
  },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-22-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-23-2025",
  // },
  // {
  //   titulo: "ITP-CAASIM-SRMYSG-SAL-02/2025",
  // },
];
